module.exports = __webpack_public_path__ + "static/media/payment-cards.37ddaecc.png";